import { defineStore } from 'pinia';
import { shallowRef } from 'vue';
import type { Component } from 'vue';
import type { ModalConfig } from '../components/Modal';

export interface ModalStoreProps {
  component: null | Component;
  props?: Record<string, unknown>;
  config?: ModalConfig;
  events?: {
    onClose?: () => void;
    onConfirm?: () => void;
    onCancel?: () => void;
  };
  labels?: {
    confirm?: string;
    confirmTestId?: string;
    cancel?: string;
    cancelTestId?: string;
  };
}

const initialState = {
  component: null,
  props: {},
  config: { blocking: true, firstSelectionOnLastItem: true },
};

export const useModalStore = defineStore('modal', () => {
  const modalState = shallowRef<ModalStoreProps>(initialState);

  const openModal = ({
    component,
    props = {},
    config = { blocking: true, firstSelectionOnLastItem: true },
    events = {},
    labels = {},
  }: ModalStoreProps) => {
    modalState.value = {
      component,
      props,
      config,
      events,
      labels,
    };
  };

  const closeModal = () => {
    if (modalState.value.events?.onClose) {
      modalState.value.events.onClose();
    }
    modalState.value = initialState;
  };

  return { modalState, openModal, closeModal };
});
